import React from 'react';


function IndexWeb(props){

    const elm=document.getElementById("PageLoader")
    if(elm){
       elm.innerHTML="1111 Customize Web System Start"
    }
    return(
        <div>
            1111 Customize Web System Start
        </div>
    )

}

export default IndexWeb;